import More from './More'
// Uncomment the below to migrate to stateful component
// import MoreContainer from './MoreContainer'

export { More }
export default More
// Uncomment the below to migrate to stateful component
// export { MoreContainer }
// export default { MoreContainer }
